import { getRgObjectsOfType as i, RG_TYPE as s } from "@project-rouge/rg-core";
const m = (e) => {
  const t = {}, o = i(e, s.Apartment);
  for (const n of o) {
    const a = n.data.category;
    t[a] || (t[a] = { count: 0, nia: 0 }), t[a].count++, t[a].nia += n.data.nia;
  }
  const r = Object.keys(t), c = o.length;
  return r.map((n) => ({
    name: n,
    count: t[n].count,
    averageNia: t[n].nia / t[n].count,
    ratio: t[n].count / c
  }));
};
export {
  m as getApartmentCategoryCounts
};
//# sourceMappingURL=index.js.map
